<div
  *ngIf="authService.isLogin"
  class="btn-group ms-0 header-user-menu"
  #headerDropdown="bs-dropdown"
  dropdown
  [modal-extention]="headerDropdown"
  (isOpenChange)="onHeaderOpen($event)"
>
  <a
    type="button"
    dropdownToggle
    id="header-user-menu-toggle"
    class="dropdown-toggle"
    aria-controls="header-user-menu-dropdown"
  >
    <div [ngClass]="{ customThemeProfile: !!themeColor }">
      <app-user-image [isHeader]="true"></app-user-image>
    </div>
  </a>
  <ul
    *dropdownMenu
    id="header-user-menu-dropdown"
    class="dropdown-menu header-dropdown-menu dropdown-menu-right"
    role="menu"
    style="z-index: 550"
    aria-labelledby="header-user-menu-toggle"
    [ngClass]="{
      'custom-edit-dropdown-theme': !!backgroundColor,
      'delegated-list-dropdown': delegatedAccessList?.length && !isAdminAccess
    }"
  >
    <li>
      <div class="header-user-menu__mobile-header d-block d-lg-none">
        <div class="icon-close-btn" (click)="hideDropdown()">
          <em class="icon-liteicon-close cursor-pointer"></em>
        </div>
        <app-user-profile></app-user-profile>
        <div class="header-user-menu__profile-actions">
          <a
            (click)="navigateToMySite()"
            class="visit-my-site ms-0"
            *ngIf="
              (userProfileData | showTabByApproval : SIDEBAR_TABS.PROFILE) &&
              checkPendingCreatorApproval
            "
          >
            {{
              userProfileData?.is_creator ? 'View My Site' : 'View My Profile'
            }}
          </a>
          <a
            *ngIf="
              !authService.isWhiteLabelWebsite() &&
              !isCreatorRequestApproved &&
              !userProfileData?.is_creator &&
              userProfileData?.isAbove18 &&
              checkPendingCreatorApproval
            "
            (click)="navigateToBecomeACreatorPage()"
            class="visit-my-site"
          >
            {{ CREATORS_CONST.CREATE_ON_TOPFANS }}
          </a>
        </div>
      </div>
    </li>
    <li
      role="menuitem"
      class="d-none d-lg-block edit-preference-item"
      *ngIf="checkPendingCreatorApproval"
    >
      <a
        (click)="editPreferences()"
        class="dropdown-item edit-preference-link"
        *ngIf="
          permissionKeys.EDIT_MY_PREFERENCES
            | hasPermission: PERMISSION_TYPE.READ : true
            | async
        "
      >
        Edit Preferences
      </a>
      <span class="dropdown-item mt-3 terms-and-privacy-links">
        <a [routerLink]="['/', ROUTE_PATHS.TERMS_OF_SERVICE]">
          {{ legalLinkLabels.TERMS }}
        </a>
        {{ legalLinkLabels.SEPARATOR }}
        <a [routerLink]="['/', ROUTE_PATHS.PRIVACY_POLICY]">
          {{ legalLinkLabels.PRIVACY_POLICY }}
        </a>
      </span>
      <span class="dropdown-item mt-3 terms-and-privacy-links"
       *ngIf="cs.isWhiteLabelWeb">
        <a [routerLink]="['/', ROUTE_PATHS.HELP_FAQ]">
          {{ legalLinkLabels.HELP_CENTER_FAQ }}
        </a>
      </span>
    </li>
    <li
      *ngIf="!isWhitelabel && !isMarketingPageVisible"
      role="menuitem"
      class="dropdown-border-item theme-selector-item d-block d-lg-none"
    >
      <div class="theme-selector-container">
        <div class="theme-selector-label">{{ headerLabels.SITE_EXPERIENCE }}</div>
        <div class="theme-circles">
          <div
            *ngFor="let theme of themes"
            class="theme-circle"
            [ngClass]="{ active: currentTheme === theme.value }"
            [title]="theme.label"
            (click)="switchTheme(theme)"
          >
            <div
              class="theme-circle-inner"
              [attr.data-theme]="theme.value"
            ></div>
          </div>
        </div>
      </div>
    </li>
    <li
      class="d-block d-lg-none dropdown-border-item"
      *ngIf="
        ((permissionKeys.EDIT_MY_PREFERENCES
          | hasPermission: PERMISSION_TYPE.READ : true
          | async) ||
          (delegatedAccessList?.length && !isAdminAccess)) &&
        checkPendingCreatorApproval
      "
    >
      <div
        *ngIf="delegatedAccessList?.length && !isAdminAccess"
        class="m-switch-user"
        (click)="preventDefault($event)"
      >
        <div
          class="d-flex align-items-center justify-content-between"
          (click)="viewDelegateProfile($event)"
        >
          <div>{{ fields.SWITCH_PROFILE }}</div>
          <div>
            <em
              *ngIf="showDelegateProfiles"
              class="icon-litechevron_up"
            ></em>
            <em
              *ngIf="!showDelegateProfiles"
              class="icon-litechevron_down"
            ></em>
          </div>
        </div>
        <ng-container *ngIf="showDelegateProfiles">
          <div
            *ngFor="let delegatedUser of delegatedAccessList"
            class="user-item"
            [ngClass]="{ 'active-user': delegatedUser.isSwitchedUser }"
            (click)="selectDelegateUser(delegatedUser)"
          >
            <div class="profileImage user-profile">
              <img
                appDisableRightClick
                appMobileOptimization
                [originalUrl]="delegatedUser?.user?.profile_image_url"
                [src]="delegatedUser?.user?.profile_image_url"
                [width]="28"
                [height]="28"
                [format]="'webp'"
                alt="User"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div class="switch-name">
              {{ delegatedUser?.user?.first_name }}
              {{ delegatedUser?.user?.last_name }}
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container
        *ngIf="
          permissionKeys.EDIT_MY_PREFERENCES
            | hasPermission: PERMISSION_TYPE.READ : true
            | async
        "
      >
        <h4>Edit Preferences</h4>
        <ul>
          <li
            *ngIf="userProfileData | showTabByApproval : SIDEBAR_TABS.PROFILE"
          >
            <a routerLink="/edit-preference">
              <em class="icon-res-editfill"></em>
              Profile
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.WELCOME_MESSAGE | hasPermission | async) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.WELCOME_MESSAGE)
            "
          >
            <a [routerLink]="[ROUTE_PATHS.EDIT_WELCOME_MESSAGE]">
              <em class="icon-liteWelcom-message-1"></em>
              {{ fields.WELCOME_MESSAGE }}
            </a>
          </li>
          <li
            *ngIf="
              (!userProfileData?.is_white_label ||
                userProfileData?.is_host_owner) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.INTERESTS)
            "
            class="whitelabel-hidemenu"
          >
            <a [routerLink]="['/edit-preference/edit-content']">
              <em class="icon-liteinterests"></em>
              {{ fields.INTERESTS }}
            </a>
          </li>
          <li
            *ngIf="
              (userProfileData | showTabByApproval : SIDEBAR_TABS.NOTIFICATIONS) &&
              !(whitelabelUserData && userProfileData?.is_creator)
            "
          >
            <a [routerLink]="['/edit-preference/notifications']">
              <em class="icon-notification"></em>
              Notifications
            </a>
          </li>
          <li
            *ngIf="
              (((permissionKeys.NFT_WALLET | hasPermission | async) &&
                !userProfileData?.is_white_label) ||
                (userProfileData?.is_white_label &&
                  userProfileData?.is_host_owner)) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.NFT_WALLET)
            "
          >
            <a [routerLink]="['/edit-preference/connect-nft-wallet']">
              <em class="icon-litenft-wallet"></em>
              NFT Wallet
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.MONETIZATION | hasPermission | async) &&
              (!userProfileData?.is_white_label ||
                (userProfileData?.is_white_label &&
                  userProfileData?.is_host_owner)) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.INTERESTS)
            "
          >
            <a [routerLink]="['/edit-preference/monetization']">
              <em class="icon-monetize-on icon-notification"></em>
              Monetization
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.PRIVACY_AND_PASSWORD | hasPermission | async) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.NOTIFICATIONS)
            "
          >
            <a [routerLink]="['/edit-preference/privacy']">
              <em class="icon-res-privacy"></em>
              {{ fields.PRIVACY_PASSWORD_INTEGRATION }}
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.CREATOR_TYPES | hasPermission | async) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.CREATOR_TYPE)
            "
          >
            <a [routerLink]="['/edit-preference/edit-creator']">
              <em class="icon-litecreator-types"></em>
              {{ fields.CREATOR_TYPE | titlecase }}
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
              (!userProfileData?.is_white_label ||
                (userProfileData?.is_white_label &&
                  userProfileData?.is_host_owner)) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.WHITE_LABELED_SITE)
            "
          >
            <a [routerLink]="['/edit-preference/whitelabel']">
              <em class="icon-res-whitelabeled"></em>
              White-Label Site
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
              hasCreatorWhitelabel &&
              cs.isWlsVerified &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.OUTBOUND_EMAILS)
            "
          >
            <a [routerLink]="[ROUTE_PATHS.OUTBOUND_EMAILS]">
              <em class="icon-litesimple-envelope"></em>
              {{ fields.OUTBOUND_EMAILS }}
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.LINK_IN_BIO | hasPermission | async) &&
              (!userProfileData?.is_white_label ||
                (userProfileData?.is_white_label &&
                  userProfileData?.is_host_owner)) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.LINK_IN_BIO)
            "
          >
            <a [routerLink]="[ROUTE_PATHS.EDIT_PREFERENCE_LIB]">
              <em class="icon-litelinkInBio"></em>
              {{ fields.LINK_IN_BIO }}
            </a>
          </li>
          <li
            *ngIf="
              !('' | hasPermission: null : false : true | async) &&
              ((permissionKeys.DELEGATION | hasPermission | async) ||
                showDelegationTab) &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.DELEGATION)
            "
          >
            <a [routerLink]="['/edit-preference/delegation']">
              <em class="icon-liteDelegate"></em>
              {{ fields.DELEGATION }}
            </a>
          </li>
          <li
            *ngIf="
              userProfileData?.is_creator &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.TOPIC_TAGS)
            "
          >
            <a [routerLink]="[ROUTE_PATHS.TOPIC_TAGS]">
              <em class="icon-litesettings"></em>
              {{ fields.TOPIC_TAGS }}
            </a>
          </li>
          <li
            *ngIf="
              (permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
              userProfileData?.is_creator &&
              (userProfileData | showTabByApproval : SIDEBAR_TABS.GAMIFICATION)
            "
          >
            <a [routerLink]="[ROUTE_PATHS.GAMIFICATION]">
              <em class="icon-litegamification"></em>
              {{ fields.GAMIFICATION }}
            </a>
          </li>
        </ul>
      </ng-container>
    </li>
    <li
      *ngIf="delegatedAccessList?.length && !isAdminAccess"
      class="delegated-list d-none d-lg-block"
    >
      <div class="switch-label">{{ fields.SWITCH_PROFILE }}</div>
      <div class="d-flex flex-column list-container">
        <div
          *ngFor="let delegatedUser of delegatedAccessList"
          class="user-item"
          [ngClass]="{ 'active-user': delegatedUser.isSwitchedUser }"
          (click)="selectDelegateUser(delegatedUser)"
        >
          <div class="profileImage user-profile">
            <img
              appDisableRightClick
              [src]="delegatedUser?.user?.profile_image_url"
            />
          </div>
          <div class="switch-name">
            {{ delegatedUser?.user?.first_name }}
            {{ delegatedUser?.user?.last_name }}
          </div>
        </div>
      </div>
    </li>
    <li
      *ngIf="!isWhitelabel && !isMarketingPageVisible"
      role="menuitem"
      class="dropdown-border-item theme-selector-item d-none d-lg-block"
    >
      <div class="theme-selector-container">
        <div class="theme-selector-label">{{ headerLabels.SITE_EXPERIENCE }}</div>
        <div class="theme-circles">
          <div
            *ngFor="let theme of themes"
            class="theme-circle"
            [ngClass]="{ active: currentTheme === theme.value }"
            [title]="theme.label"
            (click)="switchTheme(theme)"
          >
            <div
              class="theme-circle-inner"
              [attr.data-theme]="theme.value"
            ></div>
          </div>
        </div>
      </div>
    </li>
    <li role="menuitem" class="dropdown-border-item sign-out-option">
      <a
        (click)="logOut()"
        class="btn btn-basic"
        [ngStyle]="{
          background: themeColor && scrSize > screenSize.mobile ? themeColor : null,
          color: themeColor ? '#ffffff' : null
        }"
        [ngClass]="{
          'custom-sign-out-btn': themeColor && scrSize > screenSize.mobile
        }"
      >
        <span>Sign Out</span>
      </a>
    </li>
  </ul>
</div>

<app-creator-requirements-modal
  #creatorRequirementsModal
></app-creator-requirements-modal>

<app-verify-otp-modal
  #verifyOtpModal
  [sendOtpAPIUrl]="API_URLS.delegateSendOtp"
  [sendOtpPayload]="{
    action: 'delegate_2fa'
  }"
  [verifyOtpAPIUrl]="API_URLS.delegateVerifyOtp"
  [verifyOtpPayload]="verifyOtpPayload"
  (confirmed)="switchUser()"
></app-verify-otp-modal>
